import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const TestDriveDialog = ({ vehicle, open, onOpenChange }) => {
  const [form, setForm] = useState({ name: "", phone: "", preferred_date: "", preferred_time: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads/test-drive", {
        ...form,
        vehicle_id: vehicle?.id,
        vehicle_name: vehicle ? `${vehicle.year} ${vehicle.make} ${vehicle.model}` : "",
      });
      toast.success("Test drive requested! Our team will reach out shortly.");
      onOpenChange(false);
      setForm({ name: "", phone: "", preferred_date: "", preferred_time: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setSubmitting(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="test-drive-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Book a Test Drive</DialogTitle>
          <DialogDescription>
            {vehicle ? `For: ${vehicle.year} ${vehicle.make} ${vehicle.model}` : "Pick a car and schedule a visit."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input label="Your Name" required value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="td-name" />
          <Input label="Phone Number" required type="tel" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} testid="td-phone" />
          <div className="grid grid-cols-2 gap-3">
            <Input label="Preferred Date" type="date" value={form.preferred_date} onChange={(v) => setForm({ ...form, preferred_date: v })} testid="td-date" />
            <Input label="Preferred Time" type="time" value={form.preferred_time} onChange={(v) => setForm({ ...form, preferred_time: v })} testid="td-time" />
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-700">Message (optional)</label>
            <textarea rows={3} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2 text-sm" />
          </div>
          <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="td-submit">
            {submitting ? "Submitting…" : "Submit Request"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

const Input = ({ label, type = "text", value, onChange, required, testid }) => (
  <div>
    <label className="text-xs font-semibold text-gray-700">{label}{required && " *"}</label>
    <input
      type={type}
      value={value}
      required={required}
      onChange={(e) => onChange(e.target.value)}
      className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2 text-sm focus:border-[#940C2C]"
      data-testid={testid}
    />
  </div>
);
